import { EventIds } from 'constants/eventIds';
import { fallbackDatapoints } from 'constants/waveform';
import { useEffect, useState } from 'react';
import { PlayerWaveformDataPoints } from '@landr/react-player';
import { log } from 'utils/log';
import axios from 'axios';

const fallbackPlayerWaveformDataPoints = (
    guid: string,
): PlayerWaveformDataPoints => {
    return {
        original: {
            id: guid,
            value: fallbackDatapoints,
        },
        differences: [],
    };
};

export const useWaveformData = ({
    sampleGuid,
    sampleWaveformUrl,
}: {
    sampleGuid: string;
    sampleWaveformUrl?: string;
}): { dataPoints: PlayerWaveformDataPoints; loading: boolean } => {
    const [loading, setLoading] = useState(true);
    const [dataPoints, setDataPoints] = useState<PlayerWaveformDataPoints>(
        fallbackPlayerWaveformDataPoints(sampleGuid),
    );

    useEffect(() => {
        const fetchWaveform = () => {
            sampleWaveformUrl &&
                axios
                    .get(sampleWaveformUrl, {
                        headers: {
                            'Content-Type': 'application/json', // eslint-disable-line
                        },
                    })
                    .then((res) => {
                        if (res.data.dataPoints) {
                            setDataPoints({
                                original: {
                                    id: sampleGuid,
                                    value: res.data.dataPoints || [],
                                },
                                differences: [],
                            });
                        } else {
                            log.error(
                                'Get Waveform Falsy response',
                                EventIds.GetWaveformFailed,
                                new Error('Waveform Falsy Response'),
                                {
                                    guid: sampleGuid,
                                    waveformUrl: sampleWaveformUrl,
                                },
                            );
                        }
                    })
                    .catch((error: unknown) => {
                        log.warn(
                            'Get Waveform Failed',
                            EventIds.GetWaveformFailed,
                            error,
                            {
                                guid: sampleGuid,
                                waveformUrl: sampleWaveformUrl,
                            },
                        );
                    })
                    .finally(() => {
                        setLoading(false);
                    });
        };

        fetchWaveform();
    }, [sampleGuid, sampleWaveformUrl]);

    return { dataPoints, loading };
};
